import { COOKIES } from "@/constants/cookies";
import axios from "axios";
import { parseCookies } from "nookies";
import { attachUnauthorizedHandler } from "@/services/interceptors/attach-unauthorized-handler";

export const apiInventoryRequests = axios.create({
  baseURL: import.meta.env.VITE_INVENTORY_REQUESTS_API,
});

apiInventoryRequests.interceptors.request.use((config) => {
  const authCookie = parseCookies()[COOKIES.BACKOFFICE_AUTH];

  if (authCookie) {
    config.headers["auth-token"] = authCookie;
    config.headers["Authorization"] = `Bearer ${authCookie}`;
  }

  return config;
});

attachUnauthorizedHandler(apiInventoryRequests);
